import ACTIONS from "../actions";

const initialState = {
  user: {},
  isSignedIn: false,
  isAdmin: false,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SIGN_IN:
      return {
        ...state,
        isSignedIn: true,
      };
    case ACTIONS.SIGN_OUT:
      return {
        ...state,
        isSignedIn: false,
      };
    case ACTIONS.GET_USER:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
